<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('setting.set_money_pwd')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
    <van-cell-group>
  <!-- 旧密码区域：只有已设置密码的用户才需要填写 -->
  <div class="c_p_j" v-if="hasPayPassword">{{ $t('setting.old_pwd') }}</div>
  <van-field v-if="hasPayPassword" v-model="old_password" :placeholder="$t('setting.old_pwd_tip')" type="password" />

  <div class="c_p_j">{{ $t('setting.new_pwd') }}</div>
  <van-field v-model="o_new_password" :placeholder="$t('setting.new_pwd_tip')" type="password"/>

  <div class="c_p_j">{{ $t('setting.new_again_tip') }}</div>
  <van-field v-model="t_new_password" :placeholder="$t('setting.new_again_tip')" type="password"/>
</van-cell-group>
    <div class="sub-btn" @click="save()">
      {{ $t('q59') }}
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      o_new_password:"",
      t_new_password:"",
      old_password:"",
      userInfo:{},
      hasPayPassword: false  
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save() {
  // 基础验证
  if (!this.o_new_password || !this.t_new_password) {
    this.$toast.fail(this.$t("setting.prefect"));
    return false;
  }
  if (this.o_new_password !== this.t_new_password) {
    this.$toast(this.$t("setting.pwd_error"));
    return false;
  }

  // 如果用户已有密码，必须填写旧密码
  if (this.hasPayPassword && !this.old_password) {
    this.$toast.fail(this.$t("setting.old_pwd_tip"));
    return false;
  }

  let data = {
    paypassword: this.o_new_password // 新密码
  };
  if (this.hasPayPassword) {
    data.old_password = this.old_password; // 旧密码
  }

  this.$http({
    method: 'post',
    data: data,
    url: 'user_set_paypw'
  }).then(res => {
    if (res.code === 200) {
      this.$toast(res.msg);
      setTimeout(() => {
        localStorage.clear();
        this.$router.push("Login");
      }, 500);
    } else if (res.code === 401) {
      this.$toast(res.msg);
    }
  });
},
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.hasPayPassword = !!res.data.paypassword;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.sub-btn{
  background: linear-gradient(#fde3ca, #e7b486);


  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 60px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.van-cell{
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  
  /deep/ .van-field__control{
    color: #f3c7a2;
  }
  &:after{
    display: none;
  }
}
.van-cell-group{
  background-color: transparent;
  &:after{
    display: none;
  }
}
.c_p_j{
  padding: 26px 30px;
  color: #f3c7a2;
  font-size: 26px;
}
</style>
